module.exports = __webpack_public_path__ + "img/user-alt.492ddda5.svg";